let trigger = document.querySelector(".header__mobileMenuTrigger");
let header = document.querySelector(".header");
let menu = document.querySelector(".mobileMenu");
let body = document.querySelector("body");

function toggleState() {

  header.classList.contains('header--home') ? header.classList.toggle('header--transparent') : null;
  menu.classList.toggle("mobileMenu--active");
  body.classList.toggle("stopScroll");
  trigger.classList.toggle('header__mobileMenuTrigger--opened');
};

const Menu = () => {
  if (trigger) {
    trigger.addEventListener("click", () => toggleState());
  }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/js/app/components/Menu.js